import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import React from 'react'
import { bool, func, string } from 'prop-types'
import styled from 'styled-components'

const Modal = styled.div`
  background-color: ${StyleGuide.cores.branco};
  border-radius: 10px;
  margin: 0 auto;
  max-width: 530px;
  padding: 44px;
  position: relative;
  text-align: center;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  z-index: 10;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding: 15px;
    width: 95%;
  }
`

const ModalWapper = styled.div`
  background-color: rgba(19, 26, 45, 0.5);
  display: ${( { open } ) => open ? 'block' : 'none'};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
`

const WrapperButton = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 0 auto;
  max-width: ${( { noMaxWidth } ) => noMaxWidth ? '100%' : '76%'};

  > * {
    width: 100%;
    padding: 15px 20px;
    box-sizing: border-box;
    min-width: 0;
  }

  @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
    grid-template-columns: 1fr;
  }
`

const Titulo = styled.h3`
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.boldFonte};
  margin: 12px 0;
`

const Descricao = styled.p`
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.tipografia.textoGrande};
  max-width: 90%;
  margin: 0 auto 30px;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin-bottom: 25px;
  }
`

const ModalConfirmacao = ( { onClickAcaoPrimaria, acaoPrimariaTitulo, onClickAcaoSecundaria, acaoSecundariaTitulo, descricao, noMaxWidth, titulo } ) => {
  const [ open, setOpen ] = React.useState( true )

  const handleClick = () => {
    setOpen( ( state ) => !state )
  }

  return (
    <ModalWapper open={ open }>
      <Modal>
        <Titulo>
          { titulo }
        </Titulo>

        <Descricao>
          { descricao }
        </Descricao>

        <WrapperButton noMaxWidth={ noMaxWidth }>
          <Button
            invertido
            onClick={ onClickAcaoSecundaria ? onClickAcaoSecundaria : handleClick }
            target="_self"
            tema={ Button.BOTAO_CURADORIA }
          >
            { acaoSecundariaTitulo }
          </Button>

          <Button
            onClick={ onClickAcaoPrimaria ? onClickAcaoPrimaria : handleClick }
            target="_self"
            tema={ Button.BOTAO_CURADORIA }
          >
            { acaoPrimariaTitulo }
          </Button>
        </WrapperButton>
      </Modal>
    </ModalWapper>
  )
}

ModalConfirmacao.propTypes = {
  'acaoPrimariaTitulo': string.isRequired,
  'acaoSecundariaTitulo': string.isRequired,
  'descricao': string,
  'noMaxWidth': bool,
  'onClickAcaoPrimaria': func.isRequired,
  'onClickAcaoSecundaria': func.isRequired,
  'titulo': string.isRequired
}

ModalConfirmacao.defaultProps = {
  'descricao': null,
  'noMaxWidth': false
}

export default ModalConfirmacao
